import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'dmv-pub-a11y-page',
    templateUrl: './a11y-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class A11yPageComponent {
}
